import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import i18n from 'i18next';
import * as Yup from 'yup';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Modal,
  Button,
  TextField,
} from 'web-components';

const validationSchema = () => Yup.lazy(values => Yup.object().shape({
  ...(values.invite
    ? {
      email: Yup.string()
        .email('Email must be a valid email')
        .required('Email is required'),
    }
    : {
      email: Yup.string()
        .email('Email must be a valid email'),
    }
  ),
  first_name: Yup.string()
    .required('First name is required'),
  last_name: Yup.string()
    .required('Last name is required'),
}));

type Props = {
  isOpen: boolean;
  isLimitReached: boolean;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddClient = ({
  isOpen,
  onSubmit,
  isLimitReached,
  onRequestClose,
}: Props) => (isLimitReached ? (
  <Modal
    title={i18n.t('add.client.modal.reached')}
    isOpen={isOpen}
    contentStyle={{ width: 600 }}
    onRequestClose={onRequestClose}
  >
    <Flex
      column
      width="100%"
      align="center"
      spacing={15}
    >
      <Text align="center">
        {i18n.t('add.client.modal.reached.body')}
      </Text>
      <Button
        ghost
        type="submit"
        spacing="large"
        appearance="primary"
        onClick={onRequestClose}
      >
        Ok
      </Button>
    </Flex>
  </Modal>

) : (
  <Modal
    title={i18n.t('add.client.modal.title')}
    isOpen={isOpen}
    contentStyle={{ width: 500 }}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{
        email: '',
        first_name: '',
        last_name: '',
      }}
      validateOnBlur={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        isSubmitting,
        values,
        submitForm,
        setValues,
      }) => (
        <Flex
          column
          width="100%"
          as="form"
          spacing={10}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="first_name"
            label="First Name *"
            value={values.first_name}
            placeholder="e.g. John"
            component={TextField}
            autoComplete="off"
          />
          <Field
            name="last_name"
            label="Last Name *"
            value={values.last_name}
            placeholder="e.g Smith"
            component={TextField}
            autoComplete="off"
          />
          <Field
            name="email"
            label={`${i18n.format(i18n.t('client'), 'cap')}'s email`}
            value={values.email}
            placeholder="Email"
            component={TextField}
            autoComplete="off"
          />
          <Flex
            width="100%"
            margin="10px 0"
            justify="center"
            spacing={30}
          >
            <Button
              ghost
              appearance="primary"
              spacing="large"
              isLoading={isSubmitting && !values.invite}
              isDisabled={isSubmitting}
              onClick={() => {
                setValues({
                  ...values,
                  invite: false,
                });
                submitForm();
              }}
            >
              Invite later
            </Button>
            <Button
              appearance="success"
              onClick={() => {
                setValues({
                  ...values,
                  invite: true,
                });
                submitForm();
              }}
              spacing="large"
              isLoading={isSubmitting && values.invite}
              isDisabled={isSubmitting}
            >
              Invite now
            </Button>
          </Flex>
          <hr />
          <Flex
            width="100%"
            justify="center"
          >
            <Text
              color="#888"
              fontStyle="italic"
            >
              {i18n.t('add.client.modal.help')}
              <br />
              You may invite them later if you wish.
              {' '}
              <a
                href="https://gymcloud.freshdesk.com/support/solutions/articles/3000084493-client-sign-up-and-account-creation"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </Text>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
));

export default AddClient;
